import { Role } from 'src/Enum/Report';

export interface IIntroduction {
  id?: number;
  descriptionTh?: string | null;
  descriptionEn?: string | null;
}

export interface IRemark {
  id?: number;
  descriptionTh?: string | null;
  descriptionEn?: string | null;
}

export interface ICompletedSection {
  id?: number;
  isCompletedTh: boolean;
  isCompletedEn: boolean;
  roleStampTh?: Role;
  roleStampEn?: Role;
  dateTh?: string | undefined;
  dateEn?: string | undefined;
}

export const defaultCompletedSection: ICompletedSection = {
  isCompletedTh: false,
  isCompletedEn: false,
  dateTh: undefined,
  dateEn: undefined,
  roleStampTh: undefined,
  roleStampEn: undefined,
};

export interface IOtherDescription {
  id?: number;
  titleTh?: string | null;
  titleEn?: string | null;
  descriptionTh?: string | null;
  descriptionEn?: string | null;
}

export interface IAsset {
  id?: number;
  fileNameTh?: string | null;
  fileNameEn?: string | null;
  descriptionTh?: string | null;
  descriptionEn?: string | null;
  urlTh?: string;
  urlEn?: string;
  isUseSameFile: boolean;
  sequence: number;
}
